import styled, { css } from 'styled-components';
import PageToolbar from 'components/PageToolbar';
import { pageToolbarHeight } from 'styles/spacings';

// TODO: double-check if should keep `flex` here
export const PageContent = styled.div`
	display: ${({ direction }) => (direction ? 'flex' : 'block')};
	${({ direction }) =>
		direction &&
		css`
			flex-direction: ${direction};
		`};

	flex: 1;
	position: relative;

	overflow-x: hidden;
	overflow-y: ${({ scroll = true }) => (scroll ? 'auto' : 'hidden')};
	-webkit-overflow-scrolling: touch;

	height: 100%;
	${PageToolbar} + & {
		height: calc(
			100% - ${pageToolbarHeight} - ${props => props.extraHeight || '0px'}
		);
		z-index: 0;
	}
`;
